export const DEFAULTS = {
    language: 'nl-NL'
};
export const APP_ROOT_ELEMENT = 'product-pages-app';
export const SITE_NAMES = {
    zilverenkruis: 'Zilveren Kruis',
    defriesland: 'De Friesland',
    dechristelijkezorgverzekeraar: 'De Christelijke Zorgverzekeraar'
};
